type SectionLoadingStateProps = {
  label: string
  count?: number
  gridClassName?: string
  cardClassName?: string
  className?: string
}

export function LoadingSpinner({ className = '' }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block h-5 w-5 flex-none rounded-full border-2 border-slate-300 border-t-blue-600 motion-safe:animate-spin ${className}`}
    />
  )
}

export function SectionLoadingState({
  label,
  count = 4,
  gridClassName = 'grid-cols-2 md:grid-cols-4',
  cardClassName = 'h-80',
  className = '',
}: SectionLoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={className}
      data-loading-state="section"
    >
      <div className="mb-4 flex items-center gap-3 text-sm font-semibold text-slate-600">
        <LoadingSpinner />
        <span>{label}</span>
      </div>
      <div className={`grid gap-4 ${gridClassName}`} aria-hidden="true">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className={`overflow-hidden rounded-2xl border border-slate-200 bg-white ${cardClassName}`}
          >
            <div className="h-3/5 bg-slate-200 motion-safe:animate-pulse" />
            <div className="space-y-3 p-4">
              <div className="h-3 w-1/3 rounded-full bg-slate-200 motion-safe:animate-pulse" />
              <div className="h-4 w-4/5 rounded-full bg-slate-200 motion-safe:animate-pulse" />
              <div className="h-4 w-2/3 rounded-full bg-slate-200 motion-safe:animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export function PageLoadingState() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="min-h-screen bg-white text-slate-900"
      data-loading-state="page"
    >
      <div className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center gap-4 px-4">
          <div className="h-9 w-32 rounded-lg bg-slate-200 motion-safe:animate-pulse" aria-hidden="true" />
          <div className="h-10 max-w-xl flex-1 rounded-lg bg-slate-100 motion-safe:animate-pulse" aria-hidden="true" />
        </div>
      </div>
      <main>
        <div className="bg-slate-900 px-4 py-14 text-white md:py-20">
          <div className="mx-auto max-w-7xl">
            <div className="flex items-center gap-3 text-sm font-bold">
              <LoadingSpinner className="border-slate-600 border-t-blue-400" />
              <span>Memuat halaman dan data terbaru...</span>
            </div>
            <div className="mt-8 max-w-3xl space-y-4" aria-hidden="true">
              <div className="h-10 w-4/5 rounded-lg bg-slate-700 motion-safe:animate-pulse md:h-14" />
              <div className="h-5 w-full rounded bg-slate-800 motion-safe:animate-pulse" />
              <div className="h-5 w-2/3 rounded bg-slate-800 motion-safe:animate-pulse" />
              <div className="h-12 w-44 rounded-xl bg-blue-700 motion-safe:animate-pulse" />
            </div>
          </div>
        </div>
        <div className="mx-auto max-w-7xl px-4 py-14">
          <SectionLoadingState label="Memuat produk, berita, dan kategori..." />
        </div>
      </main>
    </div>
  )
}
